import { render } from "./MeCreate.vue?vue&type=template&id=1b081bed&scoped=true&ts=true"
import script from "./MeCreate.vue?vue&type=script&lang=ts"
export * from "./MeCreate.vue?vue&type=script&lang=ts"

import "./MeCreate.vue?vue&type=style&index=0&id=1b081bed&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b081bed"]])

export default __exports__